import { ProgressBar } from '@progress/kendo-react-progressbars';
import KwelloIconButton from '../../KwelloButton/KwelloIconButton';
import { KWELLO_ICON } from '../../icon/KwelloSvgIcon';
import './ExportProgressBar.scss';

export interface ExportProgressBarProps {
  value: number; // Progress percentage
  show: boolean; // Show or hide bar
  title?: string; // Top message
  subtitle?: string; // Secondary message
  onClose?: () => void; // Callback when minimized/closed
}

export function ExportProgressBar({
  value,
  show,
  title = '',
  subtitle = '',
  onClose,
}: ExportProgressBarProps) {
  if (!show) return null;

  return (
    <div className="export-progress-bar">
      <div className="export-progress-bar_text">
        <span>
          <strong>{title}</strong>
        </span>
        <br />
        <span>{subtitle}</span>
      </div>

      <div className="export-progress-bar_value">
        <ProgressBar labelVisible={false} value={value} max={100} />
        <span>{value}%</span>
      </div>

      <div className="export-progress-bar_close">
        {onClose && (
          <KwelloIconButton
            className="profiles-grid-view-profile-button"
            icon={KWELLO_ICON.X_ICON}
            onClick={onClose}
            tooltip="Minimize Progress Bar"
          />
        )}
      </div>
    </div>
  );
}
